import {
    GET_ADDRESS,
    EDIT_ADDRESS,
    ADD_ADDRESS,
    ALL_ADDRESS
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    data: null
  }
  
  const address = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ADDRESS:
        case ADD_ADDRESS:
            state = {
              ...state,
              data:action.payload.data,
              loading: false,
            }
            break
        case GET_ADDRESS:
            state = {
                ...state,
                loading: true,
            }
            break
        case ALL_ADDRESS:
            state = {
                ...state,
                data:action.payload.data,
                loading: false
            }
            break
        default:
        break
    }
    return state
  }

  export default address
  